<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<h2 class="toc0"><a href="#/xhtml/05_Acknowledgements">Acknowledgements</a></h2>
<h2 class="toc0"><a href="#/xhtml/06_Introduction">Introduction</a></h2>
<h2 class="toct"><a href="#/xhtml/07_Chapter01"><span class="space">1.</span> Fighters</a></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter02" title="Link target outside of Sample"><span class="space">2.</span> MiG Fighters</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample"><span class="space">3.</span> Bombers</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample"><span class="space">4.</span> Miscellaneous Aircraft</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample"><span class="space">5.</span> Helicopters</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?6a3ebea0